/**
 * A calculation call that did not come back — most often a 30-second timeout while the server is
 * busy ranking a few hundred strategies for the same client (owner-reported, 7 Oct 2026: an
 * "Unhandled Rejection" overlay after the Suggestion Engine finished). The figures already on screen
 * stay; the console says what was not refreshed; nothing is thrown at the page.
 */
export const quietCalc = (what: string) => (err: unknown): void => {
    const message = err instanceof Error ? err.message : String(err);
    console.warn(`[aged care] ${what} was not refreshed: ${message}`);
};
